// Intercept and modify cart fetch responses
const originalFetch = window.fetch;
window.fetch = async function (...args) {
  const response = await originalFetch(...args);

  // Only intercept cart endpoints
  if (!args[0].includes("/cart")) {
    return response;
  }

  // Clone the response so we can read it multiple times
  const clone = response.clone();

  // Handle JSON responses (XHR)
  if (response.headers.get("content-type")?.includes("application/json")) {
    const json = await clone.json();
    if (json.items) {
      await deleteFreeProduct({ detail: { cartJson: json } });
    }
    return response;
  }

  // Handle HTML responses
  if (response.headers.get("content-type")?.includes("text/html")) {
    const html = await clone.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    // Find cart items in HTML and process them
    const cartItems = Array.from(doc.querySelectorAll(".cart-item")).map(
      (item) => {
        return {
          id: item.dataset.id,
          product_id: item.dataset.productId,
          selling_plan_allocation: item.querySelector("[data-selling-plan]")
            ? {}
            : null,
          price: parseFloat(item.dataset.price || "0"),
        };
      }
    );

    if (cartItems.length) {
      await deleteFreeProduct({ detail: { cartJson: { items: cartItems } } });
    }

    return response;
  }

  return response;
};

// This function asynchronously fetches the cart items from the server.
const fetchCartItems = async () => {
  const res = await fetch("/cart.js");
  const cartItems = await res.json();
  return cartItems.items;
};

// Selects the element and parses the JSON variant list from the product list.
const cartFoot = document.querySelector(".cart-drawer__foot.cart__foot");
const jsonProduct = JSON.parse(
  document.querySelector("#gift__products").innerHTML
);
const jsonVariantList = JSON.parse(
  document.querySelector("#product-list_variant").innerHTML
);
// Removes empty field variants from the variant list.
const removeEmptyField = jsonProduct.filter((el) => el.free !== "");
const removeEmptyFieldVariantList = jsonVariantList.filter(
  (el) => el.free !== ""
);
const allJson = [...removeEmptyField, ...removeEmptyFieldVariantList];

allJson.forEach(obj => {
  obj.free = obj.free
    .split(",")
    .map(id => id.trim())
    .filter(id => id !== "");
});


function checkInCart(cartItems) {
  const mainIdsInCart = cartItems
    .filter((item) => item.hasOwnProperty("selling_plan_allocation"))
    .map((item) => Number(item.product_id));

  const freeProductsInCart = cartItems.filter((item) =>
    allJson.some((obj) => obj.free.some(f => Number(f) === Number(item.product_id)))
  );

  const itemsToRemove = [];

  console.log(freeProductsInCart,cartItems,allJson)

  for (const freeItem of freeProductsInCart) {
    const relatedRules = allJson.filter(
      (obj) => obj.free.some(f => Number(f) === Number(freeItem.product_id))
    );

    let shouldKeep = false;

    for (const rule of relatedRules) {
      const mainIds = rule.main.split(",").map((id) => Number(id.trim()));
      const hasParent = mainIds.some((id) => mainIdsInCart.includes(id));
      if (hasParent) {
        shouldKeep = true;
        break;
      }
    }

    if (!shouldKeep) {
      itemsToRemove.push(freeItem.id.toString());
    }
  }

  return {
    shouldClean: itemsToRemove.length > 0,
    triggerItems: itemsToRemove,
  };
}

let motherBundleRemoved = false;

function handleRemoveButtons() {
  const removeButtons = document.querySelectorAll("a.cart__item__remove");
  removeButtons.forEach((button) => {
    button.onclick = (e) => {
      const id = button.getAttribute("data-id");
      const correspondingProduct = document.querySelector(
        `.cart__item[data-key-item="${id}"]`
      );
      let productTitle =
        correspondingProduct.querySelector(".cart__item__title");
      if (productTitle) {
        productTitle = productTitle.textContent.trim();

        const motherBundlesJson = JSON.parse(
          document.querySelector("#mother__bundles").innerHTML
        );
        const isMotherBundle = motherBundlesJson.some((el) =>
          el.title === productTitle ? productTitle : false
        );

        if (isMotherBundle || productTitle === "IMMUNE SUPPORT 5 IN 1") {
          motherBundleRemoved = true;
        }

        if (motherBundleRemoved) {
          const stillExists = (bundleTitle) =>
            new Promise((res, rej) => {
              const currentProductList = document.querySelectorAll(
                ".cart__item__title a"
              );
              currentProductList.forEach((title) => {
                const trimmedTitle = title.textContent.trim();
                if (trimmedTitle === productTitle) {
                  rej("Not yet rerendered.");
                } else {
                  res("Rerendered");
                }
              });
              res(bundleTitle);
            });

          const resultInterval = setInterval(async () => {
            const result = await stillExists(productTitle);
            if (result === "Rerendered") {
              clearInterval(resultInterval);

              const freeProducts = document.querySelectorAll(
                ".cart__item.free_product"
              );
              if (freeProducts) {
                freeProducts.forEach((product) => {
                  const clickEvent = new Event("click", { bubbles: true });
                  product
                    .querySelector(".cart__item__remove")
                    .dispatchEvent(clickEvent);
                });
              }
              motherBundleRemoved = false;
            }
          }, 1000);
        }
      }
    };
  });
}

handleRemoveButtons();

// Checks the quantity of free products and updates the cart if needed.
function checkQuantityAndDelete(cartItem) {
  const updateDataFreeProduct = {};
  const freeProducts = cartItem.filter((el) => el.price == 0);
  freeProducts.forEach((element) => {
    const { quantity, id } = element;
    if (quantity >= 2) {
      updateDataFreeProduct[id] = 1;
    }
  });
  if (Object.keys(updateDataFreeProduct).length != 0) {
    const dataUpdateForm = {
      updates: updateDataFreeProduct,
    };
    originalFetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dataUpdateForm),
    })
      .then((res) => {
        console.log("update free products");
        console.log(res);
        return res;
      })
      .then((res) => {
        console.log(res.json());
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent("cart:update"));
        }, 1000);
      })
      .catch((error) => {
        console.log(error);
      });
  }
}

let isDeletingFreeProducts = false;
// Event handler function for the 'cart:remove' event.
const deleteFreeProduct = async (event) => {
  const items = event.detail
    ? event.detail.cartJson.items
    : await fetchCartItems();
  checkQuantityAndDelete(items);

  const { shouldClean, triggerItems } = checkInCart(items);

  let variantListSelectors = [];

  if (shouldClean) {
    variantListSelectors = triggerItems;
  }

  if (variantListSelectors.length > 0) {
    console.log(
      variantListSelectors.length,
      "variantListSelectors.length in deleteFreeProduct"
    );

    if (cartFoot) {
      cartFoot.classList.add("is-disabled");
    }

    //remove items from cart variantListSelectors one by one
    // const fetchPromises = variantListSelectors.map(async (el) => {
    //   if (!el) return;

    //   const removeData = {
    //     id: el,
    //     quantity: 0,
    //   };

    //   const response = await originalFetch(
    //     window.Shopify.routes.root + "cart/change.js",
    //     {
    //       method: "POST",
    //       headers: { "Content-Type": "application/json" },
    //       body: JSON.stringify(removeData),
    //     }
    //   );

    //   if (!response.ok) {
    //     console.error(`error id: ${removeData.id}`);
    //   }
    // });

    const updates = Object.fromEntries(variantListSelectors.map(item => [item, 0]));

    const fetchPromise = originalFetch(window.Shopify.routes.root + "cart/update.js",{
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body: JSON.stringify({updates})
    })

    console.log(updates)

    if (isDeletingFreeProducts) return;

    try {
      // await Promise.all(fetchPromises);
      await fetchPromise;
      document.dispatchEvent(
        new CustomEvent("cart:update_remove", { bubbles: true })
      );
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent("cart:update"));
      }, 1000);
      console.log("All free products removed successfully !!!!");
      isDeletingFreeProducts = true;
    } catch (error) {
      console.error("error", error);
    } finally {
      if (cartFoot) {
        cartFoot.classList.remove("is-disabled");
      }
      isDeletingFreeProducts = false;
    }
  }
};

// Run on initial page load
(async () => {
  await deleteFreeProduct({});
})();
